<!--
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-07-07 10:12:24
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2022-07-07 10:24:22
 * @FilePath: /uedc-material-system-front/src/views/layout/page-questionnaire.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <el-dialog
    custom-class="pay-tips-dialog"
    :visible.sync="tipsDialogVisible"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <div class="tips-dialog-body">
      <div class=" tips-dialog-title">自助制图用户满意度调研</div>
      <div class="tips-dialog-img"><img src="/img/questionnaire.png" height="160"/></div>
      <div>
        自助制图团队近期计划对产品进行优化升级，为了提供更好用的功能、更优良的体验，<br>诚挚邀请您填写本次问卷。
      </div>
      <div class=" tips-dialog-btns">
        <el-button class="c-button" round @click="handleClosed">关闭</el-button>
        <el-button class="c-button" type="primary" round @click="handleDetail">去填写</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import userApi from '@/request/api/user-api'
import { mapActions } from 'vuex'
export default {
  components: {},
  data () {
    return {
      tipsDialogVisible: true
    }
  },
  computed: {
    surveyUrl () {
      return this.$store.getters['app/surveyUrl']
    }
  },
  methods: {
    ...mapActions({
      setSurveyUrl: 'app/setSurveyUrl'
    }),
    handleClose () {
      // console.log('close')
      // this.tipsDialogVisible = false
      userApi.surveysClose()
    },
    handleClosed () {
      this.setSurveyUrl('')
      this.tipsDialogVisible = false
    },
    handleDetail () {
      this.tipsDialogVisible = false
      this.surveyUrl && window.open(this.surveyUrl, '_blank')
    }
  }
}
</script>
<style lang="scss">
@import 'page-contact';
</style>
